const ROMAN_NUMERAL_PATTERN = /^(M{0,3})(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/;
export const isValidRomanNumeral = (str) => (str
    ? ROMAN_NUMERAL_PATTERN.test(str)
    : false);
